function resetLocationBootstrapCache({ trackerMap, userMap } = {}) {
  if (trackerMap && typeof trackerMap.clear === 'function') {
    trackerMap.clear()
  }

  if (userMap && typeof userMap.clear === 'function') {
    userMap.clear()
  }
}

function resolveLocationRequestMode({ trackerMapSize = 0, overrideOnlyOnline } = {}) {
  const isFirstLoad = trackerMapSize === 0

  return {
    isFirstLoad,
    onlyOnline: overrideOnlyOnline !== undefined ? overrideOnlyOnline : !isFirstLoad,
  }
}

module.exports = {
  resetLocationBootstrapCache,
  resolveLocationRequestMode,
}
